module.exports = __webpack_public_path__ + "img/servicesIMG.bd07e0ab.png";